// Settings (SystemAdminPage and its blocks), Swedish (OQ-162).
export const svSettings = {
  page: {
    title: 'Inställningar',
    back: 'Tillbaka',
    orgsLoadFailed: 'Organisationerna kunde inte laddas'
  },
  shared: {
    name: 'Namn',
    urlId: 'URL-id',
    urlIdHelp:
      'URL-id används när publika länkar till en organisations innehåll skapas, t.ex. som en del av adressen för att ladda ner en fil.',
    importCsv: 'Importera CSV',
    exportCsv: 'Exportera CSV',
    csvIncorrect: 'CSV-filen har fel format',
    importSuccessful: 'Importen lyckades',
    importFailed: 'CSV-filen kunde inte importeras',
    importPartial_one: 'Importen lyckades delvis, men rad {{lines}} kunde inte importeras.',
    importPartial_other: 'Importen lyckades delvis, men raderna {{lines}} kunde inte importeras.',
    orgNamePlaceholder: 'Ange ett namn på organisationen…',
    displayNamePlaceholder: 'Ange ett nytt visningsnamn…',
    updateOrgInfo: 'Redigera organisationen',
    logo: 'Logotyp',
    logoUploaded: 'Logotypen har laddats upp',
    logoUploadFailed: 'Kunde inte ladda upp logotypen.'
  },
  roles: {
    USER: 'Användare',
    ADMIN: 'Administratör',
    SUPERADMIN: 'Systemadministratör'
  },
  accountStatus: {
    active: 'Aktivt',
    inactive: 'Inaktivt',
    pending: 'Väntar på aktivering'
  },
  userBlock: {
    title: 'Min profil',
    changePassword: 'Byt lösenord',
    editTitle: 'Ändra ditt namn',
    updateError: 'Kunde inte uppdatera användaren: {{error}}',
    updateFailed: 'Kunde inte spara namnet.',
    passwordTitle: 'Byt lösenord',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    repeatPassword: 'Upprepa lösenordet',
    wrongPassword: 'Det nuvarande lösenordet är fel',
    submitPassword: 'Byt lösenord',
    editName: 'Ändra namn',
    saved: 'Namnet har sparats',
    passwordChanged: 'Lösenordet har bytts',
    passwordFailed: 'Kunde inte byta lösenordet.'
  },
  organisationBlock: {
    title: 'Organisation',
    requireLocation: 'Kräv plats vid uppladdning',
    requireLocationHelp: 'När den är av kan bilder via kameralänkar skickas utan position.',
    updateError: 'Kunde inte uppdatera organisationen: {{error}}',
    updateFailed: 'Kunde inte spara organisationen.',
    saved: 'Organisationen har sparats'
  },
  orgColor: {
    label: 'Färg',
    help: 'Klicka på färgrutan för att välja färg eller skriv en hexkod nedan',
    placeholder: 'Ange en färg för organisationen',
    invalid: 'Organisationens hexkod för färgen har fel format'
  },
  generalBlock: {
    title: 'Allmänt',
    editOrg: 'Redigera organisation',
    created: 'Skapad',
    urlIdPlaceholder: 'Ange ett unikt URL-id…',
    urlIdNotUnique: 'Organisationens URL-id är inte unikt',
    urlIdBadFormat: 'Organisationens URL-id har fel format',
    updateError: 'Kunde inte uppdatera organisationen: {{error}}',
    updateFailed: 'Kunde inte spara organisationen.'
  },
  accountBlock: {
    title: 'Användare',
    addAccount: 'Lägg till användare',
    adminLocked: 'Bara systemadministratören kan ändra administratörer',
    orgIdNotFound: 'Organisationens id hittades inte.',
    columnEmail: 'E-post',
    columnRole: 'Roll',
    columnStatus: 'Status',
    loadFailed: 'Kontona kunde inte laddas.',
    empty: 'Organisationen har inga användare än.',
    activateTitle: 'Aktivera kontot?',
    deactivateTitle: 'Inaktivera kontot?',
    resendConfirm: 'Vill du skicka en ny aktiveringslänk till det här kontot?',
    sendEmail: 'Skicka',
    activateConfirm: 'Vill du aktivera det här kontot?',
    deactivateConfirm: 'Vill du inaktivera det här kontot?',
    activate: 'Aktivera',
    deactivate: 'Inaktivera',
    deleteTitle: 'Ta bort användaren?',
    deleteConfirm: '{{name}} tas bort och kan inte längre logga in. Det går inte att ångra.',
    deleteError: 'Kunde inte ta bort kontot: {{error}}',
    deleteFailed: 'Kunde inte ta bort användaren.',
    createTitle: 'Lägg till användare',
    editTitle: 'Redigera användare',
    email: 'E-post',
    emailPlaceholder: 'Ange användarens e-postadress…',
    role: 'Roll',
    saveError: 'Kunde inte spara användaren: {{error}}',
    unknownError: 'Okänt fel',
    saveFailed: 'Kunde inte spara användaren: {{error}}',
    addUser: 'Lägg till användare',
    resendTitle: 'Skicka aktiveringslänken igen?',
    resent: 'En ny aktiveringslänk har skickats till {{email}}',
    resendFailed: 'Kunde inte skicka aktiveringslänken.',
    activated: '{{name}} har aktiverats',
    deactivated: '{{name}} har inaktiverats',
    statusFailed: 'Kunde inte ändra kontots status.',
    deleteButton: 'Ta bort användaren',
    deleted: '{{name}} har tagits bort',
    created: '{{email}} har lagts till och fått en aktiveringslänk',
    saved: '{{email}} har sparats'
  },
  statusBlock: {
    title: 'Statusar',
    newStatus: 'Lägg till status',
    columnText: 'Text',
    columnIndex: 'Ordning',
    empty: 'Organisationen har inga statusar än.',
    deleteTitle: 'Ta bort statusen?',
    deleteConfirm: 'Statusen "{{name}}" tas bort. Det går inte att ångra.',
    deleteError: 'Kunde inte ta bort statusen: {{error}}',
    deleteFailed: 'Kunde inte ta bort statusen.',
    created: 'Statusen {{text}} har lagts till',
    saved: 'Statusen {{text}} har sparats',
    createError: 'Kunde inte skapa statusen: {{error}}',
    updateError: 'Kunde inte uppdatera statusen: {{error}}',
    createFailed: 'Kunde inte lägga till statusen.',
    updateFailed: 'Kunde inte spara statusen.',
    createTitle: 'Lägg till status',
    editTitle: 'Redigera status',
    namePlaceholder: 'Ange ett namn på statusen…',
    text: 'Text',
    textPlaceholder: 'Ange texten som visas för statusen…',
    sortIndex: 'Ordning',
    addStatus: 'Lägg till status',
    deleteButton: 'Ta bort statusen',
    deleted: 'Statusen {{name}} har tagits bort'
  },
  organisationsBlock: {
    title: 'Organisationer',
    addOrg: 'Lägg till organisation',
    columnLinkId: 'Länk-id',
    empty: 'Det finns inga organisationer än.',
    verified: 'Kontot {{email}} är verifierat.',
    wrongPassword: 'Fel lösenord.',
    deleteTitle: 'Ta bort organisationen?',
    orgName: 'Organisationens namn:',
    orgId: 'Organisationens id:',
    verifyLabel: 'Du måste ange ditt lösenord och verifiera ditt konto för att göra detta',
    passwordPlaceholder: 'Ange ditt lösenord…',
    accountVerified: 'Kontot är verifierat',
    verifyAccount: 'Verifiera kontot',
    permanentWarning: 'Åtgärden är <strong><u>permanent</u> och tar bort all data</strong>',
    deleteError: 'Kunde inte ta bort organisationen: {{error}}',
    deleteFailed: 'Kunde inte ta bort organisationen.',
    deleteOrg: 'Ta bort organisationen',
    createTitle: 'Lägg till organisation',
    linkIdPlaceholder: 'Ange ett unikt länk-id…',
    linkIdNotUnique: 'Organisationens länk-id är inte unikt',
    linkIdBadFormat: 'Organisationens länk-id har fel format',
    createError: 'Kunde inte skapa organisationen: {{error}}',
    createFailed: 'Kunde inte lägga till organisationen.',
    showPassword: 'Visa lösenordet',
    hidePassword: 'Dölj lösenordet',
    deleted: 'Organisationen {{name}} har tagits bort',
    created: 'Organisationen {{name}} har lagts till'
  },
  backupBlock: {
    title: 'Säkerhetskopior',
    columnDate: 'Datum',
    empty: 'Inga säkerhetskopior har gjorts än. Säkerhetskopior skapas kl. 01:00 varje natt.',
    restoreTitle: 'Återställ säkerhetskopian?',
    restoreConfirm: 'Vill du återställa säkerhetskopian från <strong>{{date}}</strong>?',
    restoreError: 'Kunde inte återställa säkerhetskopian: {{error}}',
    restoreFailed: 'Kunde inte återställa säkerhetskopian.',
    restoreExplain:
      'Ärendena i säkerhetskopian läggs tillbaka och skriver över ändringar som gjorts i dem sedan dess. Ärenden som har lagts till efter {{date}} finns kvar.',
    restoreButton: 'Återställ',
    restored: 'Säkerhetskopian från {{date}} har återställts'
  }
};
